import React from 'react'
import { Checkbox, Col, ControlLabel, FormGroup, Row } from 'react-bootstrap'
import { FMF_M, ILM } from '../../constants/programConstants'
import TermsConditionsDialog from './termsConditionsDialog'

export const TermsAndConditions = ({
  acceptedTC,
  program,
  showDetailsText,
  showDialog,
  onOpenDialog,
  onCloseDialog,
  setAcceptedTC,
  isMeditatorChecked,
  setIsMeditatorChecked,
  isVaccineChecked,
  setIsVaccineChecked
}) => {
  return (
    <div>
      <Row className='ml-neg-154'>
        <Col md={3} className='terms-condition-link pull-right'>
          <span>
            I have read{' '}
            <a className='terms-conditions-link' onClick={onOpenDialog}>
              Terms and Conditions
            </a>
          </span>
        </Col>
        <FormGroup>
          <Col md={1} className='terms-check-box pull-right'>
            <Checkbox
              disabled={false}
              checked={acceptedTC}
              onChange={value => setAcceptedTC(value)}
              style={{ marginRight: '16px' }}
            />
          </Col>
        </FormGroup>
      </Row>

      {program === FMF_M && showDetailsText && (
        <Row>
          <Col xs={12} md={7} mdPush={3}>
            <FormGroup style={{ display: 'flex', alignItems: 'center' }}>
              <Checkbox
                disabled={false}
                checked={isMeditatorChecked}
                onChange={value => setIsMeditatorChecked(value)}
              />
              <ControlLabel style={{ textAlign: 'left' }}>
                I have taken the Inner Engineering program, including initiation
                into Shambhavi Mahamudra Kriya
              </ControlLabel>
            </FormGroup>
          </Col>
        </Row>
      )}

      {program === ILM && showDetailsText && (
        <Row>
          <Col xs={12} md={7} mdPush={3}>
            <FormGroup style={{ display: 'flex', alignItems: 'center' }}>
              <Checkbox
                disabled={false}
                checked={isVaccineChecked}
                onChange={event => {
                  console.log({ event })
                  setIsVaccineChecked(event.target.checked)
                }}
              />
              <ControlLabel style={{ textAlign: 'left' }}>
                I am fully vaccinated against Covid-19. I understand that
                Without RT-PCR test results, or with a positive result, stay at
                Isha Institute will not be allowed and your booking will be
                cancelled and refunded per policy.
              </ControlLabel>
            </FormGroup>
          </Col>
        </Row>
      )}

      <TermsConditionsDialog showDialog={showDialog} closeFn={onCloseDialog} />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/searchBar/termsAndConditions.js